export default __webpack_public_path__ + "static/44-ba007c9a2e58582e83fb3eecfe7db03b.jpg";